import {initializeApp} from "firebase/app";
import {getMessaging, getToken, onMessage, isSupported} from "firebase/messaging";

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

console.log("FIREBASE DEBUG: Loaded config is", firebaseConfig);

// Initialize Firebase safely via a Singleton Promise
let messagingInstancePromise = null;

export const initMessaging = () => {
  if (!messagingInstancePromise) {
    messagingInstancePromise = (async () => {
      if (firebaseConfig.apiKey && firebaseConfig.apiKey !== "YOUR_API_KEY") {
        try {
          const supported = await isSupported();
          if (supported) {
            const app = initializeApp(firebaseConfig);
            return getMessaging(app);
          } else {
            console.warn("Firebase Messaging is not supported in this browser/environment (e.g., HTTP instead of HTTPS).");
          }
        } catch (e) {
          console.error("Firebase messaging initialization failed:", e);
        }
      } else {
        console.warn("Firebase config is missing or invalid.");
      }
      return null;
    })();
  }
  return messagingInstancePromise;
};

// Request permission and generate FCM token
export const requestFirebaseToken = async () => {
  const messaging = await initMessaging();

  if (!messaging) {
    console.warn("Firebase Messaging is not supported or not yet initialized.");
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      // For mobile devices, we MUST pass the service worker registration to getToken
      let tokenOptions = {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      };

      if ("serviceWorker" in navigator) {
        const registration = await navigator.serviceWorker.ready;
        tokenOptions.serviceWorkerRegistration = registration;
      }

      const currentToken = await getToken(messaging, tokenOptions);
      if (currentToken) {
        console.log("FCM Token Generated:", currentToken);
        // You should send this token to your backend API here
        return currentToken;
      } else {
        console.log("No registration token available. Request permission to generate one.");
      }
    } else {
      console.log("Firebase Notification permission denied");
    }
  } catch (err) {
    console.error("An error occurred while retrieving firebase token. ", err);
  }
  return null;
};

// Listen to foreground messages
export const onForegroundMessage = async (callback) => {
  const messaging = await initMessaging();
  if (!messaging) return;

  onMessage(messaging, (payload) => {
    console.log("Foreground Message received: ", payload);
    callback(payload);
  });
};
